<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3043 15.4498H8.9043"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2605 11.4385H8.90454"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.1604 8.29988L14.4904 2.89988C13.7604 2.79988 12.9404 2.74988 12.0404 2.74988C5.75039 2.74988 3.65039 5.06988 3.65039 11.9999C3.65039 18.9399 5.75039 21.2499 12.0404 21.2499C18.3404 21.2499 20.4404 18.9399 20.4404 11.9999C20.4404 10.5799 20.3504 9.34988 20.1604 8.29988Z"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.9336 2.83252V5.49352C13.9336 7.35152 15.4396 8.85652 17.2976 8.85652H20.2486"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    clr: {
      default: "#500FE9"
    }
  }
};
</script>
